import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AutosuggestPopupItemSkeleton } from "../../Skeleton/autoSuggestPopup/autosuggestPopupItemSkeleton";
import { ConvertToFloat } from "../../Layout/Common/common";
import { contructProductData } from "../../Layout/Common/algoliaInstantLib";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { useAuth } from "../../Context/AuthContext";

export const ItemContainer = ({ item }) => {
  const [product, setProduct] = useState(null);
  const { priceCode } = useAuth();
  useEffect(() => {
    if (item) {
      var data = contructProductData(item, null);
      setProduct(data);
    }
  }, [item]);
  return (
    <Fragment>
      {product ? (
        <div
          key={product.productId ?? 0}
          className="col-4 col-sm-3 col-md-2 col-lg-2 search-results mt-3"
          data-id={product.productId}
        >
          <Link to={product.wesProductUrl} className="cc-serach-result">
            <div className="product-list search-product-list">
              <div className="product-items search-product-items">
                <ImageWithDefault src={product.imageUrl1 ?? product.algoliaIMAGEURL} alt="product-name" />
              </div>
              <div className="product-details">
                <div style={{ height: "40px", overflow: "hidden" }}>
                  <h6 className="product-title" style={{ lineBreak: "anywhere" }}>
                    {product.productDescriptions}
                  </h6>
                </div>
                <h5
                  className="product-code product-title mb-0"
                  style={{
                    lineBreak: "anywhere",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {product.sku}
                </h5>
                <div className="product-price">
                  <p>${ConvertToFloat(product[`prodExtPri${priceCode}`] ?? product.prodExtPri3)}</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      ) : (
        <AutosuggestPopupItemSkeleton />
      )}
    </Fragment>
  );
};
